module.exports = __webpack_public_path__ + "img/layers-button.0f9652bc.svg";